import { AlertTriangle, LogOut } from 'lucide-react';
import type { POSShift } from '@/types';

type Props = {
  shift: POSShift;
  onCloseShift: () => void;
};

export default function ShiftExpiredModal({ shift, onCloseShift }: Props) {
  const limit = shift.max_shift_hours ?? 24;

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        <div className="px-6 py-5 bg-red-50 border-b border-red-100 flex items-start gap-3">
          <AlertTriangle className="w-6 h-6 text-red-600 shrink-0 mt-0.5" />
          <div>
            <h3 className="text-lg font-semibold text-red-950">Shift time limit reached</h3>
            <p className="text-sm text-red-800 mt-1">
              Your shift has been open for {shift.hours_open?.toFixed(1) ?? limit} hours. The allowed limit is{' '}
              {limit} hours. Please close this shift and open a new one to continue selling.
            </p>
          </div>
        </div>
        <div className="px-6 py-5 space-y-3">
          <p className="text-sm text-gray-600">
            Shift <strong>{shift.name}</strong> · Started {new Date(shift.shift_start).toLocaleString()}
          </p>
          <button
            type="button"
            onClick={onCloseShift}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-red-600 hover:bg-red-700 text-white font-medium transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Close shift now
          </button>
        </div>
      </div>
    </div>
  );
}
